import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import Overview from "./components/Overview";
import Timeline from "./components/Timeline";
import Finale from "./components/Finale";
import Moments from "./components/Moments";
import Topics from "./components/Topics";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50 shadow-lg shadow-primary-600/30 transition-transform hover:-translate-y-1 hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line" aria-hidden="true" />
    </a>
  );
}

export default function Home() {
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-[60] focus:rounded-lg focus:bg-background-50 focus:px-4 focus:py-2">
        跳到主要内容
      </a>
      <Header />
      <main id="main">
        <Hero />
        <StatsBar />
        <Overview />
        <Timeline />
        <Finale />
        <Moments />
        <Topics />
        <Guide />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}